var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainWarp"},[_vm._m(0),_c('div',{staticClass:"dataWrap"},[_c('RingDiagram',{attrs:{"data":_vm.data}}),_c('RingDiagram',{attrs:{"data":_vm.dataTwo}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-title"},[_c('img',{attrs:{"src":"/iconImg/h_title_bg.png"}}),_c('span',{staticClass:"DataTitle"},[_vm._v("维修指标")])])
}]

export { render, staticRenderFns }